/**
 * Maximale plaatmaat per glasdikte (Timmers prijslijst pag. 5).
 *
 * Waarom hier: de Timmers-API geeft voor bijna elk glas géén maximum mee (0 of 9999), waardoor
 * de catalogus terugviel op een verzonnen 3000 × 2000 mm. Dat is voor dun glas te ruim en voor
 * dik glas juist veel te krap — een plaat van 8 mm mag tot 2800 × 6000 mm. De tabel staat als
 * JSON in `../data/max-plate.json` zodat de sync-transform (een .mjs-buildscript) hem uit
 * dezelfde bron kan lezen; anders zouden twee kopieën uit elkaar lopen.
 *
 * Let op: dit is de plaatmaat van FLOATGLAS (en daarvan afgeleide soorten als Lacobel/Matelac).
 * Gelaagd en gehard-gelaagd hebben hun eigen, grotere plaat (3210 × 6000, glass-manual.json) —
 * die staat expliciet in de catalogus en gaat vóór. Daarom wordt deze tabel bewust NIET als
 * generieke bovengrens in `validateGlassConfig` gelegd: dan zou gelaagd ten onrechte op 2800 mm
 * worden afgekapt. De afdwinging loopt via de plaatmaat die in de catalogus staat.
 */
import table from "../data/max-plate.json";

export interface MaxPlateMm {
  /** Korte plaatzijde (mm). */
  shortMm: number;
  /** Lange plaatzijde (mm). */
  longMm: number;
}

interface Row {
  totDikteMm: number;
  kortMm: number;
  langMm: number;
}

const ROWS: Row[] = [...(table.rijen as Row[])].sort((a, b) => a.totDikteMm - b.totDikteMm);

/**
 * De maximale plaatmaat voor een dikte: de eerste rij waarvan de dikte binnen `totDikteMm` valt,
 * anders de dikste rij (dikker dan 19 mm is maatwerk en volgt de 19 mm-regel).
 */
export function maxPlateForThickness(thicknessMm: number): MaxPlateMm {
  const row = ROWS.find((r) => thicknessMm <= r.totDikteMm) ?? ROWS[ROWS.length - 1]!;
  return { shortMm: row.kortMm, longMm: row.langMm };
}
